import React from 'react';
import { Modal, Button, Card, Row, Col, Space } from 'antd';

import { useScreenSize } from '../../../hooks';
import { Organization } from 'models/organization';
import { useOrganizationInvitation } from './hooks';

type ModalProps = {
  invitations: Organization[];
};

export function OrganizationInvitationsModal(props: ModalProps) {
  const isSmallScreen = useScreenSize();

  const { isSaving, accept, decline } = useOrganizationInvitation();

  const handleAccept = async (code: string) => {
    await accept(code);
  };

  const handleDecline = async (code: string) => {
    await decline(code);
  };

  return (
    <Modal title="New invitations" visible={props.invitations.length > 0} closable={false} footer={null} width={720} wrapClassName={isSmallScreen ? 'fullscreen' : ''}>
      <Space>
        {props.invitations.map((org) => {
          return (
            <Card key={org.invitationCode} size="small" style={{ width: 300 }} title={org.name}>
              <Row justify="space-evenly">
                <Col>
                  <Button type="primary" danger disabled={isSaving} onClick={() => handleAccept(org.invitationCode!)}>
                    Decline
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" disabled={isSaving} onClick={() => handleDecline(org.invitationCode!)}>
                    Accept
                  </Button>
                </Col>
              </Row>
            </Card>
          );
        })}
      </Space>
    </Modal>
  );
}
